
export default function(fileWidget) {
    $('a.delete-file-field', fileWidget).on('click', function(e) {
        if (!fileWidget.hasClass('is-deleted')) {
            // mark deleted
            fileWidget.find('input[type="hidden"]').val('delete');
            fileWidget.find('input[type="file"]').attr('disabled', true);
            $(this).attr('aria-disabled', true);
            fileWidget.addClass('is-deleted');
        } else {
            // remove mark
            fileWidget.find('input[type="hidden"]').val('');
            fileWidget.find('input[type="file"]').attr('disabled', false);
            $(this).attr('aria-disabled', false);
            fileWidget.removeClass('is-deleted');
        }
    })
}
